import { useState } from 'react';
import { GroupType } from '@/types/schemas';

const useData = (defaultGroup: GroupType) => {
  const [activeGroup, setActiveGroup] = useState<GroupType>(defaultGroup);
  const handleFilter = (groupType: GroupType) => {
    setActiveGroup(groupType);
  };

  return {
    activeGroup,
    handleFilter
  };
};

export default useData;
